import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { allctaInteraction, initiPageInfo } from '../common/services/adobe-service';
import { CookieHandlerService } from '../common/services/cookieHandler.service';
import { RouteContextProvider } from '../common/services/routeContextProvider.service';
import { CommonConstants } from '../common/utilities/commonConstants';
import { EpbitlyService } from './epbitly.service';

@Component({
  selector: 'app-epbitly',
  templateUrl: './epbitly.component.html',
  styleUrls: ['./epbitly.component.scss']
})
export class EpbitlyComponent implements OnInit {
  sessionId: string;
  pan: any;
  ntcSettings: { data: { mobileNumber: any; dateOfBirth: any; }; returnURL: string; occupationIdentifier: any; };
  mobileNumber: string;
  dateOfBirth: string;
  productCode: string;
  source: string;
  appUtmSource: string;
  appUtmMedium: string;
  appUtmCampaign: string;
  appUtmContent: string;
  appUtmTerm: string;
  utmObj: { utm_source: string; utm_medium: string; utm_campaign: string; utm_content: string; utm_term: string; };
  showlinkExpireMsg = false;
  applicationid: string;
  applicationKey: string;
  productId;
  paramsObj: any;
  constructor(
    private _epbitlyService: EpbitlyService,
    private _routeContextProvider: RouteContextProvider,
    private _cookieHandler: CookieHandlerService,
    private __activatedRoute:ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.checkQueryParams();
    this.getParamsObj();
    this.applicationKey = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.applicationid);
    this.productId = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.productCode);
    initiPageInfo('EP Bitly Link','AA', 'open arch:ep', this.productId, '', '', this.applicationKey, '', '', 'EP','','','','','');// account aggregator call on page load
    this.addAdobeScript();
  }

  getParamsObj(){
    this.__activatedRoute.queryParams.subscribe(params => {
     this.paramsObj = params;
  });
}
  private checkQueryParams(): void {
    this.applicationid = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.applicationid);
    this.productCode = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.productCode);
    sessionStorage.setItem(CommonConstants.QueryParamsKeys.applicationid,this.applicationid);
    sessionStorage.setItem(CommonConstants.QueryParamsKeys.productCode,this.productCode);
    this.source = CommonConstants.QueryParamsKeys.source;
    this.appUtmSource = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmSource);
    this.appUtmMedium = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmMedium);
    this.appUtmCampaign = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmCampaign);
    this.appUtmContent = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmContent);
    this.appUtmTerm = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.appUtmTerm);
    this.sessionId = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.sessionId);
    this.productId = this._routeContextProvider.GetQueryParams(CommonConstants.QueryParamsKeys.productid);
    sessionStorage.setItem(CommonConstants.SharedServiceDataKeys.productid, this.productId);
    sessionStorage.setItem(CommonConstants.SharedServiceDataKeys.sourceChannel,'WEB_EP');
    this.utmObj = {
      utm_source: this.appUtmSource, utm_medium: this.appUtmMedium, utm_campaign: this.appUtmCampaign, utm_content: this.appUtmContent, utm_term: this.appUtmTerm
    }
    this.getUIToken(this.productCode)
  }

  getUIToken(productCode: any) {
    this._cookieHandler.deleteCookie(CommonConstants.CookieKeysAA.authtoken);
    this._epbitlyService.getUIToken(productCode).subscribe((res: any) => {
     // this._cookieHandler.SetCookie(CommonConstants.CookieKeysAA.authtoken, res.headers.get(CommonConstants.CookieKeysAA.headerResAuth));  
      if (res.status === 200) {
        this.sessionUIToken();
      }
    });
  }
  sessionUIToken(){
      const requestPayload = {
        "sessionId": this.sessionId
      };
      this._epbitlyService.sessionUIToken(requestPayload).subscribe({
        next: (res) => {
          if (res.status === 200 || res.status === 204) {
            this._cookieHandler.deleteCookie(CommonConstants.CookieKeysAA.authtoken);
            this._cookieHandler.SetCookie(CommonConstants.CookieKeysAA.authtoken, res.headers.get(CommonConstants.CookieKeysAA.headerResAuth));  
            this.consentAccount(); 
          }
          else if(res.status === 500){
            this.showlinkExpireMsg = true;
          }
        },
        error: () => {
          console.log('error')
        }
      });
  }
  consentAccount() {
    const requestPayload = {
      "sessionId": this.sessionId
    };
    this._epbitlyService.consentAccount(requestPayload).subscribe({
      next: (res) => {
        // this._cookieHandler.deleteCookie(CommonConstants.CookieKeysAA.authtoken);
        // this._cookieHandler.SetCookie(CommonConstants.CookieKeysAA.authtoken, res.headers.get(CommonConstants.CookieKeysAA.headerResAuth));
        if (res.status === 200) {
          this.showlinkExpireMsg =false;
          this.pan = res?.payload?.pan;
          this.mobileNumber = res?.payload?.mobileNumber;
          this.dateOfBirth = res?.payload.dateOfBirth;
          const occupationType = this.productCode;
          this.ntcSettings = {
            data: {
              "mobileNumber": this.mobileNumber,
              "dateOfBirth": this.dateOfBirth
            },
            returnURL: window.location.pathname,
            occupationIdentifier: occupationType
          }
          if (res?.payload?.pan) {
            this.ntcSettings.data['pan'] = res?.payload?.pan;
          }

        }
        else if(res.status === 500){
          this.showlinkExpireMsg = true;
        }
      },
      error: () => {
        console.log('error')
      }
    });
  }
  clearFipData(){
    const bank = sessionStorage.getItem(CommonConstants.finvuStorageKeys.fipDetails);
    const consent = sessionStorage.getItem(CommonConstants.finvuStorageKeys.ConsentApproved);
    bank && sessionStorage.removeItem(CommonConstants.finvuStorageKeys.fipDetails);
    consent && sessionStorage.removeItem(CommonConstants.finvuStorageKeys.ConsentApproved);
  }

   epbitlyFlow(){
    this.clearFipData();
    allctaInteraction('ep bitly', 'Link your bank account', this.productId, 'EP', '','','','','');
    sessionStorage.setItem(CommonConstants.QueryParamsKeys.partnerType, CommonConstants.AAPartners.finvu);
    sessionStorage.setItem(CommonConstants.QueryParamsKeys.dob,this.ntcSettings.data["dateOfBirth"] ? this.ntcSettings.data["dateOfBirth"] : null );
    // sessionStorage.setItem(CommonConstants.QueryParamsKeys.dob,this.ntcSettings?.data?.dateOfBirth);
    sessionStorage.setItem(CommonConstants.setAaStorageKeySingleLink.mobileNumber,this.ntcSettings?.data?.mobileNumber);
    sessionStorage.setItem(CommonConstants.setAaStorageKey.occupationIdentifier, this.ntcSettings.occupationIdentifier);
    sessionStorage.setItem(CommonConstants.setAaStorageKey.source, CommonConstants.QueryParamsKeys.source);
    this.navigateToFinvu();
  }
  
  navigateToFinvu() {
   // let queryParams = new HttpParams({fromObject: this.utmObj}).toString();
   let newObj = Object.entries(this.paramsObj).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {});
    this._routeContextProvider.NavigateToViewWithQueryParams([CommonConstants.Routes.StandAloneBankSelection],newObj)
    // const finvuUrl = environment.serviceBaseUrls.DOMAIN02 + CommonConstants.partnerBaseUrl.finvu + '?' + queryParams;
    // window.open(finvuUrl, '_self');
  }
  private addAdobeScript() {
    // attach adobe script to body tag
    const script = document.createElement('script');
    script.setAttribute('src', environment.adobefinvuScript);
    script.setAttribute('type', 'text/javascript');
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }
}
